import styled from 'styled-components';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { ASSETS } from '../../../../../../assets';
import { THEME } from '../../../../../../themes';
import Select from '../../../../../../components/Common/select/select.component';
import { hexToRgbA } from '../../../../../../utils/colors';

export const Container = styled.div`
  
`;

export const Icon = styled(ASSETS.SCHEDULE_MEETING)`
  height: 24px;
`;

export const ActionComponent = styled.div`
  display: flex;
  gap: ${THEME.SPACING.TINY};
`;

export const DayTypeSelect = styled(Select)`
  width: 170px;
`;

export const StyledTimePicker = styled(TimePicker).attrs({
  sx: {
    backgroundColor: THEME.COLORS.PURE_WHITE,
    borderRadius: THEME.RADIUS.ROUNDISH,
    fontFamily: 'Gilroy',
    fontWeight: 'bold',
    width: '105px',

    '& .MuiOutlinedInput-root': {
      fontFamily: 'Gilroy',
      fontWeight: 'bold',
      fontSize: '14px',
      height: '40px',

      '& fieldset': {
        borderColor: hexToRgbA(THEME.COLORS.PRIMARY, THEME.OPACITY.DIVIDER),
        borderRadius: THEME.RADIUS.ROUNDISH,
      },
      '&:hover fieldset': {
        borderColor: hexToRgbA(THEME.COLORS.PRIMARY, THEME.OPACITY.DIVIDER),
      },
      '&.Mui-focused fieldset': {
        borderColor: THEME.COLORS.ACCENT,
        borderWidth: '1px',
      },
    },
  },
})``;
